import { IIconBase } from '..'

const collectDataIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.2704 5.83344H2.73619C1.87286 5.83344 1.17285 5.12762 1.17285 4.27012V2.73595C1.17285 1.87261 1.87869 1.17261 2.73619 1.17261H11.2704C12.1337 1.17261 12.8337 1.87845 12.8337 2.73595V4.27012C12.8337 5.12762 12.1279 5.83344 11.2704 5.83344Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.2704 12.8334H2.73619C1.87286 12.8334 1.17285 12.1276 1.17285 11.2701V9.73595C1.17285 8.87261 1.87869 8.17261 2.73619 8.17261H11.2704C12.1337 8.17261 12.8337 8.87845 12.8337 9.73595V11.2701C12.8337 12.1276 12.1279 12.8334 11.2704 12.8334Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.5 2.91675V4.08341'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.83301 2.91675V4.08341'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.5 9.91675V11.0834'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.83301 9.91675V11.0834'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.16699 3.5H10.5003'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.16699 10.5H10.5003'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default collectDataIcon
